import {NgModule} from '@angular/core'
import {RouterModule, Routes} from '@angular/router'
import {CraftsmenRegionPageComponent} from './region-page/craftsmen-region-page.component'
import {CraftsmenRegionPageResolver} from './region-page/craftsmen-region-page.resolver'
import {CraftsmenRegionPagesContentService} from '../../../core/content/services/craftsmen-region-pages-content.service'
import {IndustryRegionPageComponent} from './industry-region-page/industry-region-page.component'
import {IndustryRegionPageResolver} from './industry-region-page/industry-region-page.resolver'
import {RegionDirectoryPageComponent} from './region-directory-page/region-directory-page.component'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'

const routes: Routes = [
  {
    path: '',
    component: RegionDirectoryPageComponent,
    pathMatch: 'full',
  },
  {
    path: PUBLIC_ROUTES.CRAFTSMEN_REGION_PAGE.routingPath,
    children: [
      {
        path: '',
        component: CraftsmenRegionPageComponent,
        pathMatch: 'full',
        resolve: {
          content: CraftsmenRegionPageResolver,
        },
      },
      {
        path: PUBLIC_ROUTES.CRAFTSMEN_REGION_INDUSTRY_PAGE.routingPath,
        component: IndustryRegionPageComponent,
        pathMatch: 'full',
        resolve: {
          content: IndustryRegionPageResolver,
        },
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [CraftsmenRegionPageResolver, CraftsmenRegionPagesContentService, IndustryRegionPageResolver],
})
export class CraftsmenRegionDirectoryRoutingModule {}
